<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <div v-if="loading">Carregando disparos...</div>
        <material-card
          color="success"
          title="Disparos"
          text="Disparos enviados para comunicação"
        >
          <v-container>
            <v-layout>
              <v-flex xs12 md6 class="text-lg-left">
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Buscar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6 class="text-md-right text-lg-center">
                <v-btn
                  class="ml-2 mr-2 mx-0 font-weight-light"
                  color="primary"
                  :disabled="loading"
                  @click.prevent="openMailingDialog"
                >
                  <v-icon left>send</v-icon>Enviar Disparo
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
          <template v-slot:loading>
            <v-progress-linear
              v-if="loading"
              height="2"
              color="cyan"
              indeterminate
            ></v-progress-linear>
          </template>
          <v-data-table
            dense
            light
            :headers="headers"
            :items="items"
            v-if="!loading"
            :loading="loading"
            rows-per-page-text="Linhas por página"
            no-data-text="Não há disparos cadastrados"
            :search="search"
            :pagination.sync="pagination"
          >
            <template v-slot:items="props">
              <td>{{ props.item.created_at | formatarData }}</td>
              <td>{{ props.item.name || props.item.filename }}</td>
              <td>{{ props.item.owner }}</td>
              <td>{{ props.item.type }}</td>
              <td>
                <v-icon color="green" v-if="props.item.solved">{{
                  props.item.solved | formatStatus
                }}</v-icon>
                <v-progress-circular
                  v-else
                  indeterminate
                  color="grey"
                ></v-progress-circular>
              </td>
            </template>
            <template v-slot:no-results>
              <v-alert :value="true" color="error" icon="warning">
                Sua busca para "{{ search }}" Não encontrou resultados.
              </v-alert>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
    <cpnSendMailing />
  </v-container>
</template>
<script>
import firestore from "../firebase/firestore";
import moment from "moment";
import SendMailing from "../components/bulkMailing/SendMailing";
import { eventBus } from "../main";
export default {
  data() {
    return {
      items: [],
      loading: false,
      search: "",
      headers: [
        {
          text: "Criado em",
          align: "left",
          sortable: true,
          value: "created_at",
        },
        {
          text: "Nome",
          align: "left",
          sortable: false,
          value: "name",
        },
        { text: "Solicitante", value: "owner" },
        { text: "Tipo", value: "type" },
        { text: "Status", value: "solved" },
      ],
      pagination: {
        rowsPerPage: 10, // -1 for All",
      },
    };
  },
  components: {
    cpnSendMailing: SendMailing,
  },
  async created() {
    this.loading = true;
    // unsubscribe can be called to stop listening for changes
    await firestore
      .collection("bulk_messaging")
      .orderBy("created_at", "desc")
      .onSnapshot({ includeMetadataChanges: true }, (res) => {
        const changes = res.docChanges();
        if (changes.length <= 0) {
          this.loading = false;
          return;
        }
        changes.forEach((change) => {
          const { newIndex, oldIndex, doc, type } = change;
          if (change.type === "added") {
            let new_doc = {
              ...doc.data(),
              id: change.doc.id,
            };
            this.items.splice(newIndex, 0, new_doc);
            this.loading = false;
            // if we want to handle references we would do it here
          } else if (change.type === "modified") {
            // remove the old one first
            this.items.splice(oldIndex, 1);
            // if we want to handle references we would have to unsubscribe
            // from old references' listeners and subscribe to the new ones
            let new_doc = {
              ...change.doc.data(),
              id: change.doc.id,
            };
            this.items.splice(newIndex, 0, new_doc);
          } else if (type === "removed") {
            this.items.splice(oldIndex, 1);
            // if we want to handle references we need to unsubscribe
            // from old references
          } else {
            this.loading = false;
          }
        });
      });
  },
  filters: {
    formatarData: function (value) {
      if (!value) return "";
      if (value._seconds) {
        let timestamp = value; // firebase data
        let myDate = new Date(timestamp._seconds * 1000); // date object
        return moment(myDate).format("DD/MM/YYYY HH:mm");
      } else if (value.seconds) {
        let timestamp = value; // firebase data
        let myDate = new Date(timestamp.seconds * 1000); // date object
        return moment(myDate).format("DD/MM/YYYY HH:mm");
      } else {
        let myDate = value.toDate();
        return moment(myDate).format("DD/MM/YYYY HH:mm");
      }
    },
    formatStatus: function (value) {
      if (value) return "done";
      else return "schedule";
    },
  },
  methods: {
    openMailingDialog() {
      eventBus.$emit("dialog_send_mailing", true); // emit the event to the bus
    },
  },
};
</script>
<style scoped></style>
